import React, { FC } from 'react'
import { useScroll } from 'Pages/landings/common/hooks/useScroll'
import { Button } from 'Pages/landings/common/components/Button'
import './style.scss'
import { LandingNames } from 'Pages/landings/common/constants'
import { useAdriverPixel } from 'Pages/landings/common/hooks'

export const SliderComponent: FC = () => {
	const { scrollIntoBlock } = useScroll()
	const containerRef = useAdriverPixel(LandingNames.CREDITS)

	const className = {
		slider: 'landing-credits_slider',
		left: 'landing-credits_slider_left',
		right: 'landing-credits_slider_right',
		title: 'landing-credits_slider_left_title',
		subtitle: 'landing-credits_slider_left_subtitle',
		list: 'landing-credits_slider_left_list',
		button: 'landing-credits_slider_left_button',
	}

	return (
		<div ref={containerRef} className={className.slider}>
			<div className={className.left}>
				<div>
					<div className={className.title}>Кредиты для бизнеса на любые цели</div>
					<div className={className.subtitle}>
						На недвижимость, транспорт, модернизацию производства или пополнение оборотных средств —
						с&nbsp;возможностью подачи заявки онлайн
					</div>
					<Button wide onClick={() => scrollIntoBlock('#blockForm')}>
						Подать заявку онлайн
					</Button>
				</div>
			</div>
			<div className={className.right}>
				<div>
					<img src="../img/people_credits.png" alt="" />
				</div>
			</div>
		</div>
	)
}
